import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
// import sinAccesoCard from "../../../components/sin-acceso-card";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import "../../../style/style-ag-grid.css";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import { obtenerEmpresasDeEmpresaPlataforma } from "../../../api/api-empresa";
import moment from "moment";
import { sharedNextPage } from "../../../utils/shared-functions";
// import { sharedNextPage } from "../../../utils/shared-functions";
ModuleRegistry.registerModules([AllCommunityModule]);

export default function EmpresasCreadasPage() {

    const history = useHistory();
    const location = useLocation();
    const [cargandoPage, setCargandoPage] = useState(true);
    // const [titulo, setTitulo] = useState("");
    const [rowData, setRowData] = useState([]);

    const columnDefs = [
        {
            key: "acciones", headerName: "ACCIONES", width: 250,
            cellRenderer: (params) => {
                // console.log('cellRenderer');
                // console.log(params);
                return (
                    <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                        <button
                            onClick={() => btnDetallesOnClick(params.data)}
                            style={{
                                backgroundColor: "#1E90FF",
                                color: "white",
                                border: "none",
                                padding: "5px 10px",
                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                        >
                            Detalles
                        </button>
                    </div >
                );
            }
        },
        { field: "id", headerName: "ID", hide: true },
        { field: "codigo", headerName: "CODIGO", filter: true, sortable: true, },
        { field: "nombre", headerName: "NOMBRE", filter: true, sortable: true, },
        { field: "emailrepresentante", headerName: "EMAIL REPRESENTANTE", filter: true, sortable: true, },
        { field: "telefonoempresa", headerName: "TELEFONO EMPRESA", filter: true, sortable: true, },
        { field: "totalactivo", headerName: "TOTAL ACTIVO", filter: true, sortable: true, },
        { field: "fechamodificacion", headerName: "FECHA MODIFICACION", filter: true, sortable: true, },
        { field: "habilitado", headerName: "HABILITADO", filter: true, sortable: true, },
    ];

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const data = location.state;
            // console.log("data");
            // console.log(data);
            let objEnviar = { id: data.id };
            /*let obj = {};
            obj.idMenuPrimerNivel = INT_ID_MODULO_CHECKLIST;
            obj.idMenuSegundoNivel = INT_ID_SEGUNDO_NIVEL_ADMINISTRACION_CHECKLIST;
            obj.idMenuTercerNivel = INT_ID_TERCER_NIVEL_CHECKLIST_OPCIONES_RESPUESTA;
            let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(obj);
            let permiso = obtenerPermisos[0];
            setPermisos(permiso);
            */
            const fechaFin = moment().endOf("month").format("YYYY-MM-DD");
            // const fechaInicio = moment().startOf("month").format("YYYY-MM-DD");
            objEnviar.fechaFin = fechaFin;
            let permiso = null;
            let lista = [];

            lista = await obtenerEmpresasDeEmpresaPlataforma(objEnviar);
            // console.log('lista');
            // console.log(lista);
            agregarAccionesALista(lista, permiso);
            // setTieneAccesoAlModulo(true);
            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    const agregarAccionesALista = (lista, permiso) => {
        try {
            setRowData(lista);
        } catch (err) {
            console.log('agregarAccionesALista err');
            console.log(err);
        }
    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const reset = async () => {
        setCargandoPage(true);
        iniciar();
    };

    const btnDetallesOnClick = (data) => {
        console.log('btnDetallesOnClick', data);
        let obj = {};
        // obj.params = data;
        obj.idEmpresa = data.id;
        // console.log('obj');
        // console.log(obj);
        sharedNextPage("eventos-empresa", obj, history);
    };

    const render = () => {
        try {
            // console.log('listar correo render');
            if (cargandoPage === true) {
                return cargandoCard();
            }
            return (
                <div className="pt-4 px-4">
                    <div className="flex justify-between">
                        <label
                            style={{
                                fontWeight: 'bold',
                            }}
                        >
                            EMPRESAS DEPENDIENTES
                        </label>
                        <div className="flex justify-center">
                            <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_ATRAS}
                                onClick={(handleAtrasClick)}
                            >
                                ATRAS
                            </button>
                        </div>
                    </div>
                    <div className="flex justify-between gap-4">
                        {/* Button (3/12 columns) */}
                        <div className="flex items-end">
                            <button
                                type="button"
                                className={`${ESTILO_BOTON_MODAL_ACEPTAR} w-full`}
                                onClick={() => reset()}
                            >
                                ACTUALIZAR
                            </button>
                        </div>
                    </div>
                    <div
                        className="ag-theme-alpine pt-4"
                        style={{
                            height: "512px",
                            width: "100%",
                            // "--ag-header-background-color": `${primaryColor}`,
                        }}
                    >
                        <AgGridReact
                            rowData={rowData}
                            columnDefs={columnDefs}
                            pagination={true}
                            rowHeight={50}
                        />
                    </div>
                </div>
            );
        } catch (err) {
            console.log('EventosEmpresaPage render err');
            console.log(err);
            return (
                <div><label>{JSON.stringify(err)}</label></div>
            );
        }
    }

    return render();
}
